import { render } from "./HistoriqueDevisTab.vue?vue&type=template&id=77f042b9&scoped=true&ts=true"
import script from "./HistoriqueDevisTab.vue?vue&type=script&lang=ts"
export * from "./HistoriqueDevisTab.vue?vue&type=script&lang=ts"

import "./HistoriqueDevisTab.vue?vue&type=style&index=0&id=77f042b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f042b9"]])

export default __exports__